import { AbstractApiModel } from './abstract-api-model';

export class StoreScheduleEventInstance extends AbstractApiModel<StoreScheduleEventInstance> {

  storeScheduleEventId: number;
  eventType: string;
  recurrenceType: string;
  playId: number;
  playName: string;
  playType: string;
  scheduledDate: Date;

  deserialize(json: any): this {
    this.storeScheduleEventId = json.store_schedule_event_id;
    this.eventType = json.event_type;
    this.playId = json.play_id;
    this.playName = json.play_name;
    this.playType = json.play_type;
    this.recurrenceType = json.recurrence_type;
    this.scheduledDate = json.scheduled_date && new Date(json.scheduled_date);

    return super.deserialize(json);
  }

}
